import { RegisterProvider } from './reducer/RegisterProvider';
import { RegisterPage } from './RegisterPage';
import { Navigate, useLocation } from 'react-router-dom';
import { Routes } from '@xolv-mybrightlink/common';
import { useAuthRedirect } from '../auth/useAuthRedirect';

export const Register = () => {
  useAuthRedirect('AUTHENTICATED', Routes.authenticated);
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber;
  if (!phoneNumber) {
    return <Navigate to={Routes.login} />;
  }
  return (
    <RegisterProvider phoneNumber={phoneNumber}>
      <RegisterPage />
    </RegisterProvider>
  );
};
